import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDiasDaGrade, AvisoDiasDaGrade } from '../../components/GradeHoraria';
import { useNavigate, useLocation } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
    Container,
    ContainerDivs,
    Header,
    Title,
    Subtitle,
    Card,
    FieldLabel,
    DateField,
    HelperNote,
    SaveButton,
    Button,
    DateChip,
    QuickRow,
    QuickLabel,
    QuickChips,
    QuickChip,
    EditorWrap,
    EditorFooter,
    ErrorMessage,
    ClosedNotice,
    ToGoBack,
    SignMessageButtonText,
    SignMessageButtonTextBold,
} from './style';
import LoadingSpinner from '../../components/Loading';
import {
    RecordClassTaught,
    getIstQuarter,
    getIIndQuarter,
    getIIIrdQuarter,
    getIVthQuarter,
    clssInfo,
    getSchoolYear,
    getSchoolDays,
    GetMatter
} from '../../Api';

// sugestões rápidas que podem ser inseridas com um clique
const QUICK_SUGGESTIONS = [
    'Conteúdo: ',
    'Atividade em sala: ',
    'Tarefa de casa: ',
    'Revisão de ',
    'Correção de exercícios',
    'Avaliação',
    'Leitura e interpretação',
    'Continuação da aula anterior',
];

const MONTHS_PT = [
    'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
];

const Grade = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [open, setopen] = useState('aberto')
    const [id_teacher, setId_teacher] = useState('')
    const [selectedDate, setSelectedDate] = useState('');
    const [selected, setSelected] = useState('');
    const [day, setDay] = useState('');
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [description, setDescription] = useState('');
    const [id_employee, setId_employee] = useState('');

    const [RegentTeacher, setclassRegentTeacher] = useState([]);
    const [id_teacher02, setclassRegentTeacher02] = useState([]);
    const [physicalEducation, setPhysicalEducationTeacher] = useState([]);

    const [id_class, setId_class] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [schoolDays, setSchoolDays] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [prefillData, setPrefillData] = useState(null);  // data vinda dos dias sem aula

    // matérias da escola (filtradas pelo tipo de professor)
    const [matters, setMatters] = useState([]);

    const location = useLocation();
    const { employee } = location.state || {};

    const quillRef = useRef(null);

    // extrai um id string limpo de array/objeto/string
    const extractId = (v) => {
        if (!v) return null
        if (Array.isArray(v)) v = v[0]
        if (v && typeof v === 'object') v = v._id ?? v.id ?? null
        const s = String(v ?? '').trim()
        return /^[a-fA-F0-9]{24}$/.test(s) ? s : null
    }

    const safeParse = (raw) => {
        try { return raw ? JSON.parse(raw) : null } catch { return null }
    }

    // grade horária: só os dias em que o professor tem aula nesta turma (+ sábados letivos)
    const gradeDias = useDiasDaGrade(id_class, extractId(id_employee) || extractId(id_teacher))

    useEffect(() => {
        let cancelled = false
            ; (async () => {
                setLoading(true);

                const idSchool = safeParse(sessionStorage.getItem("id-school"));
                const regent = safeParse(sessionStorage.getItem("classRegentTeacher"));
                const regent02 = safeParse(sessionStorage.getItem("classRegentTeacher02"));
                const physical = safeParse(sessionStorage.getItem("physicalEducationTeacher"));
                const idClassStored = sessionStorage.getItem("class-info");

                setId_teacher(employee);
                setId_employee(employee);
                setclassRegentTeacher(regent);
                setclassRegentTeacher02(regent02);
                setPhysicalEducationTeacher(physical);
                setId_class(idClassStored);

                // veio pelo botão "Registrar Aula" dos dias sem aula?
                // o dia/mês/ano foram gravados no sessionStorage. Pré-preenche
                // a data e marca para validar automaticamente após carregar os
                // dias letivos. Em seguida limpa o storage para não vazar depois.
                const sd = safeParse(sessionStorage.getItem("day"));
                const sm = safeParse(sessionStorage.getItem("month"));
                const sy = safeParse(sessionStorage.getItem("year"));
                if (sd && sm && sy) {
                    const d = String(sd).padStart(2, "0");
                    const m = String(sm).padStart(2, "0");
                    const y = String(sy);
                    const iso = `${y}-${m}-${d}`;
                    setDay(d);
                    setMonth(m);
                    setYear(y);
                    setSelected(iso);
                    setPrefillData({ day: d, month: m, year: y, selected: iso });
                    sessionStorage.removeItem("day");
                    sessionStorage.removeItem("month");
                    sessionStorage.removeItem("year");
                }

                const yearRes = await getSchoolYear(idSchool);
                if (cancelled) return;
                const schoolYearValue = yearRes?.data?.data;

                // dias letivos + matérias da escola em paralelo
                const [schoolDaysRes, matterRes] = await Promise.all([
                    getSchoolDays(idSchool, schoolYearValue),
                    GetMatter(idSchool)
                ])
                if (cancelled) return

                if (schoolDaysRes?.data) {
                    setSchoolDays(schoolDaysRes.data.schoolDays)
                }

                // valores crus (string) para comparar com Id_employee, igual à página de seleção
                const regentRaw = sessionStorage.getItem("classRegentTeacher")
                const regent02Raw = sessionStorage.getItem("classRegentTeacher02")
                const physicalRaw = sessionStorage.getItem("physicalEducationTeacher")
                const idEmployeeRaw = localStorage.getItem("Id_employee")


                const allMatters = matterRes?.data?.data || []
                let filtered = allMatters
                if (regentRaw === idEmployeeRaw || regent02Raw === idEmployeeRaw) {
                    filtered = allMatters.filter(m => m && m.name !== 'EDUCAÇÃO FÍSICA')
                } else if (physicalRaw === idEmployeeRaw) {
                    filtered = allMatters.filter(m => m && m.name === 'EDUCAÇÃO FÍSICA')
                }
                setMatters(filtered)

                setLoading(false);
            })();
        return () => { cancelled = true };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employee]);

    // dispara a validação/verificação de período automaticamente quando a
    // data veio dos dias sem aula (prefillData) e os dias letivos já carregaram.
    useEffect(() => {
        if (!prefillData || schoolDays.length === 0) return;
        handleDateChange(prefillData);
        setPrefillData(null); // garante execução única
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prefillData, schoolDays]);

    const stripHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };

    // texto puro digitado (para contador e validação)
    const plainText = useMemo(() => stripHtml(description).trim(), [description]);

    // data por extenso para exibição amigável
    const friendlyDate = useMemo(() => {
        if (!day || !month || !year) return '';
        const mi = Number(month) - 1;
        const mName = MONTHS_PT[mi] || '';
        return `${day} de ${mName} de ${year}`;
    }, [day, month, year]);

    // insere sugestão no ponto do cursor (ou no fim)
    const insertSuggestion = (text) => {
        const editor = quillRef.current?.getEditor?.();
        if (editor) {
            const range = editor.getSelection(true);
            const pos = range ? range.index : editor.getLength();
            editor.insertText(pos, text);
            editor.setSelection(pos + text.length);
            editor.focus();
        } else {
            setDescription(prev => `${prev}${text}`);
        }
    };

    const handleSubmit = async () => {
        const plainDescription = stripHtml(description);

        const teacherId = extractId(id_employee) || extractId(id_teacher)
        const physicalId = extractId(physicalEducation)
        const regentId = extractId(RegentTeacher)
        const regent02Id = extractId(id_teacher02)

        const isPhysical = !!physicalId && teacherId === physicalId

        if (!teacherId) {
            setErrorMessage('Professor inválido. Volte e selecione o professor novamente.');
            return;
        }
        if (!id_class) {
            setErrorMessage('Turma inválida. Recarregue a página e tente novamente.');
            return;
        }
        if (!plainDescription.trim()) {
            setErrorMessage('Descreva a aula antes de registrar.');
            return;
        }

        setErrorMessage('');
        setSubmitting(true);

        let res;
        try {
            if (isPhysical) {
                res = await RecordClassTaught(
                    day, month, year, plainDescription, teacherId, null, id_class
                );
            } else {
                res = await RecordClassTaught(
                    day, month, year, plainDescription, regentId, regent02Id || null, id_class
                );
            }

            if (res && (res.ok || res.status === 200)) {
                navigate(-1);
            } else {
                const msg = res?.msg || res?.data?.msg
                    || 'Erro, verifique os dados e tente novamente.';
                setErrorMessage(msg);
            }
        } catch (err) {
            console.error('Erro ao registrar aula:', err);
            setErrorMessage('Não foi possível registrar. Verifique sua conexão e tente novamente.');
        } finally {
            setSubmitting(false);
        }
    };

    const messageButtonClick = () => {
        navigate(-1);
    };

    const handleChange = (e) => {
        const dateValue = e.target.value;
        setSelected(dateValue);
        const [year, month, day] = dateValue.split('-');
        setDay(day);
        setMonth(month);
        setYear(year);
        // avisa na hora se o dia não está na grade horária da turma
        if (dateValue && !gradeDias.permitido(dateValue)) setErrorMessage(gradeDias.mensagem(dateValue));
        else setErrorMessage('');
    };

    // valida a data contra os dias letivos e verifica o status do período.
    // aceita uma data opcional (usada pelo fluxo automático vindo dos dias
    // sem aula); se não vier, usa o estado `selected`/`day`/`month`/`year`.
    const handleDateChange = async (override) => {
        const d = override?.day ?? day
        const m = override?.month ?? month
        const y = override?.year ?? year
        const sel = override?.selected ?? selected

        if (!sel && !(d && m && y)) return

        const formattedDate = `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
        const isValid = schoolDays.includes(formattedDate);

        if (!isValid) {
            setErrorMessage("Data selecionada não é um dia letivo.");
            setSelectedDate("");
            return;
        }

        if (!gradeDias.permitido(formattedDate)) {
            setErrorMessage(gradeDias.mensagem(formattedDate));
            setSelectedDate("");
            return;
        }

        setErrorMessage("");
        setSelectedDate(sel || formattedDate);

        const fetchQuarters = async () => {
            const idSchool = sessionStorage.getItem("id-school");
            const dateSelected = new Date(y, m - 1, d);

            const [IstQuarter, IIndQuarter, IIIrdQuarter, IVthQuarter] =
                await Promise.all([
                    getIstQuarter(y, JSON.parse(idSchool)),
                    getIIndQuarter(y, JSON.parse(idSchool)),
                    getIIIrdQuarter(y, JSON.parse(idSchool)),
                    getIVthQuarter(y, JSON.parse(idSchool))
                ]);

            const getQuarterStatus = (quarterData) => {
                return quarterData.data.data
                    .map((res) => {
                        const startDate = new Date(res.startyear, res.startmonth - 1, res.startday);
                        const endDate = new Date(res.endyear, res.endmonth - 1, res.endday);
                        if (dateSelected >= startDate && dateSelected <= endDate) {
                            return res.bimonthly;
                        }
                        return null;
                    })
                    .find((res) => res);
            };

            return {
                IstQuarter: getQuarterStatus(IstQuarter) || null,
                IIndQuarter: getQuarterStatus(IIndQuarter) || null,
                IIIrdQuarter: getQuarterStatus(IIIrdQuarter) || null,
                IVthQuarter: getQuarterStatus(IVthQuarter) || null,
            };
        };

        const run = async () => {
            const [result, resClass] = await Promise.all([
                fetchQuarters(),
                clssInfo(id_class)
            ]);

            const turma = resClass.data.data[0];

            const myId = extractId(id_teacher)
            const physicalId = extractId(physicalEducation)
            const isPhysical = !!physicalId && myId === physicalId

            const pick = (key) => isPhysical
                ? turma.dailyStatus[key].physicalEducationTeacher
                : turma.dailyStatus[key].regentTeacher;

            if (result.IstQuarter) setopen(pick("1º BIMESTRE"));
            if (result.IIndQuarter) setopen(pick("2º BIMESTRE"));
            if (result.IIIrdQuarter) setopen(pick("3º BIMESTRE"));
            if (result.IVthQuarter) setopen(pick("4º BIMESTRE"));
        };

        run();
        setLoading(false)
    };

    const quillModules = useMemo(() => ({
        toolbar: [
            [{ 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
        ]
    }), []);
    // o que mostrar nos chips: matérias da escola; se não houver, as frases padrão
    const hasMatters = matters.length > 0;

    return (
        <Container>
            {loading ? (
                <LoadingSpinner />
            ) : (
                <ContainerDivs>
                    {/* ── ETAPA 1: selecionar a data ── */}
                    {!selectedDate && (
                        <>
                            <Header>
                                <Title>📅 Registrar Aula</Title>
                                <Subtitle>Comece escolhendo a data da aula lecionada</Subtitle>
                            </Header>

                            <form
                                onSubmit={(e) => { e.preventDefault(); handleDateChange(); }}
                                style={{ display: "contents" }}
                            >
                                <Card>
                                    <DateField>
                                        <FieldLabel>📆 Data da aula</FieldLabel>
                                        <input
                                            type="date"
                                            value={selected}
                                            onChange={handleChange}
                                        />
                                    </DateField>

                                    <HelperNote>
                                        ℹ️ Apenas datas que sejam dias letivos podem ser registradas.
                                    </HelperNote>
                                    <AvisoDiasDaGrade grade={gradeDias} />

                                    {errorMessage && (
                                        <ErrorMessage>⚠️ {errorMessage}</ErrorMessage>
                                    )}

                                    <SaveButton type="submit">Continuar →</SaveButton>
                                </Card>
                            </form>

                            <ToGoBack onClick={messageButtonClick}>
                                <SignMessageButtonText>← Voltar para a</SignMessageButtonText>
                                <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                            </ToGoBack>
                        </>
                    )}

                    {/* ── ETAPA 2: descrição da aula ── */}
                    {selectedDate && (
                        open === 'aberto' ? (
                            <>
                                <Header>
                                    <Title>📝 Descrição da Aula</Title>
                                    <Subtitle>Descreva o que foi trabalhado nesta aula</Subtitle>
                                </Header>

                                <Card>
                                    <DateChip>
                                        <span className="icon">📅</span>
                                        <div className="text">
                                            <span className="label">Data da aula</span>
                                            <span className="value">
                                                {friendlyDate || `${day}/${month}/${year}`}
                                            </span>
                                        </div>
                                    </DateChip>

                                    <QuickRow>
                                        <QuickLabel>
                                            {hasMatters
                                                ? '📚 Sugestões de disciplinas (toque para inserir)'
                                                : '⚡ Sugestões rápidas (toque para inserir)'}
                                        </QuickLabel>
                                        <QuickChips>
                                            {hasMatters
                                                ? matters.map((m) => (
                                                    <QuickChip
                                                        key={m._id}
                                                        type="button"
                                                        onClick={() => insertSuggestion(`${m.name}: `)}
                                                    >
                                                        {m.name}
                                                    </QuickChip>
                                                ))
                                                : QUICK_SUGGESTIONS.map((s) => (
                                                    <QuickChip
                                                        key={s}
                                                        type="button"
                                                        onClick={() => insertSuggestion(s)}
                                                    >
                                                        {s.trim()}
                                                    </QuickChip>
                                                ))
                                            }
                                        </QuickChips>
                                    </QuickRow>

                                    <EditorWrap>
                                        <ReactQuill
                                            ref={quillRef}
                                            theme="snow"
                                            modules={quillModules}
                                            value={description}
                                            onChange={setDescription}
                                            placeholder="Descreva o conteúdo, atividades e tarefas desta aula…"
                                        />
                                        <EditorFooter $empty={plainText.length === 0}>
                                            <span className="hint">
                                                💡 Use a barra acima para formatar (negrito, listas, cores).
                                            </span>
                                            <span className="count">
                                                {plainText.length} caractere{plainText.length === 1 ? '' : 's'}
                                            </span>
                                        </EditorFooter>
                                    </EditorWrap>

                                    {errorMessage && (
                                        <ErrorMessage>⚠️ {errorMessage}</ErrorMessage>
                                    )}

                                    <Button
                                        onClick={handleSubmit}
                                        disabled={submitting || plainText.length === 0}
                                    >
                                        {submitting ? 'Registrando…' : '✓ Registrar Aula'}
                                    </Button>
                                </Card>

                                <ToGoBack onClick={messageButtonClick}>
                                    <SignMessageButtonText>← Voltar para a</SignMessageButtonText>
                                    <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                                </ToGoBack>
                            </>
                        ) : (
                            <>
                                <Header>
                                    <Title>🔒 Bimestre fechado</Title>
                                </Header>
                                <ClosedNotice>
                                    <span className="icon">🔒</span>
                                    <h3>Este bimestre está fechado</h3>
                                    <p>Para editar ou registrar aulas, entre em contato com o Diretor ou Supervisor da escola.</p>
                                </ClosedNotice>
                                <ToGoBack onClick={messageButtonClick}>
                                    <SignMessageButtonText>← Voltar para a</SignMessageButtonText>
                                    <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                                </ToGoBack>
                            </>
                        )
                    )}
                </ContainerDivs>
            )}
        </Container>
    );
};

export default Grade;